module.exports = __webpack_public_path__ + "static/img/ExpressDelivery.3bca666b.png";